export const INVALID_IDENTITY_DOCUMENT_VALUE =
  'INVALID_IDENTITY_DOCUMENT_VALUE';
export const IDENTITY_DOCUMENT_NUMBER = 'identityDocumentNumber';
export const SECONDARY_IDENTITY_DOCUMENT_NUMBER =
  'secondaryIdentityDocumentNumber';
export const CRS_TAX_DETAILS = 'crsTaxDetails';

export const IDENTITY_DOCUMENT_ERROR_CONTENT = {
  crsTaxDetails: 'crs.errors.invalidTaxID.default',
  identityDocumentNumber: 'fieldErrors.identityDocumentNumberInvalid',
  secondaryIdentityDocumentNumber:
    'fieldErrors.secondaryIdentityDocumentNumberInvalid',
} as const;
